<template>
	<v-row class="ma-0 pa-0 fila">
		<v-dialog
			v-model="show"
			persistent
			content-class="elevation-0 dialogFormModal pa-6 "
		>
			<div class="formModalCloseIcon">
				<v-icon class="formModalCloseIconButton" @click="closeDialogForm"
					>mdi-close</v-icon
				>
			</div>
			<v-form
				ref="form"
				lazy-validation
				@submit.prevent="submitForm"
				class="form-container pa-2 ma-0"
			>
				<v-flex class="body-container">
					<v-flex class="secondary-v-flex">
						<h2>{{ $t("avalibleOrganism") }}</h2>
						<v-text-field
							:placeholder="$t('search')"
							single-line
							append-icon="mdi-magnify"
							color="white"
							v-model="leftFilter"
						></v-text-field>
						<v-list
							multiple
							active-class=""
							class="list-box secondary-list-box"
						>
							<v-list-item
								v-for="(org, index) in leftListFiltered"
								:key="index"
							>
								<template v-if="org" v-slot:default="{ active }">
									<v-list-item-action>
										<v-checkbox
											v-model="leftValues[index]"
											:input-value="active"
										></v-checkbox>
									</v-list-item-action>

									<v-list-item-content>
										<v-list-item-title>{{ org.name }}</v-list-item-title>
									</v-list-item-content>
								</template>
							</v-list-item>
						</v-list>
					</v-flex>
					<v-flex md2 align-self-center text-center>
						<v-btn
							class="mx-2 white--text"
							color="#216985"
							@click="moveToRight"
							:disabled="disableLeft"
						>
							<v-icon>mdi-arrow-right</v-icon>
						</v-btn>
						<v-btn
							class="mx-2 white--text"
							color="#216985"
							@click="moveToLeft"
							:disabled="disableRight"
						>
							<v-icon>mdi-arrow-left</v-icon>
						</v-btn>
					</v-flex>
					<v-flex md5>
						<h2>{{ $t("sharedOrganim") }}</h2>
						<v-text-field
							:placeholder="$t('search')"
							single-line
							append-icon="mdi-magnify"
							color="white"
							v-model="rightFilter"
						></v-text-field>
						<v-list
							multiple
							active-class=""
							class="list-box secondary-list-box"
						>
							<v-list-item
								v-for="(org, index) in rightListFiltered"
								:key="index"
								class="custom-list-item"
							>
								<template v-if="org" v-slot:default="{ active }">
									<v-list-item-action>
										<v-checkbox
											v-model="rightValues[index]"
											:input-value="active"
										></v-checkbox>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>{{ org.name }}</v-list-item-title>
									</v-list-item-content>
								</template>
							</v-list-item>
						</v-list>
					</v-flex>
				</v-flex>
				<div class="footer-container">
					<v-btn
						class="cancel-btn mr-6 btn-cancel v-btn v-btn--flat v-btn--text theme--light v-size--default"
						@click="closeDialogForm"
					>
						{{ $t("cancelButton") }}
					</v-btn>
					<v-btn
						color="#216985"
						@click="updateSecondarys"
						class="btn-confirm white--text btn-confirm v-btn v-btn--contained v-btn--rounded theme--light v-size--default"
						:disabled="!ableConfirm"
					>
						{{ $t("acceptButton") }}
					</v-btn>
				</div>
			</v-form>
		</v-dialog>
	</v-row>
</template>

<script>
export default {
	name: "SecondaryOrganismModal",
	props: {
		secondaryOrganisms: {
			type: Array,
		},
		projectOrganism: {
			type: Object,
		},
		projectId: {
			type: Number,
		},
	},
	components: {},
	data() {
		return {
			show: true,
			avalaibleOrganisms: [],
			selectedOrganisms: [],
			leftFilter: "",
			rightFilter: "",
			leftValues: [],
			rightValues: [],
		};
	},
	beforeMount() {},
	mounted() {
		this.getOrganisms();
	},
	computed: {
		leftListFiltered() {
			if (!this.avalaibleOrganisms.length) return [];
			return this.avalaibleOrganisms.filter((org) =>
				org.name.includes(this.leftFilter)
			);
		},
		rightListFiltered() {
			if (!this.selectedOrganisms.length) return [];
			return this.selectedOrganisms.filter((org) =>
				org.name.includes(this.rightFilter)
			);
		},
		disableRight() {
			return this.rightValues.indexOf(true) == -1;
		},
		disableLeft() {
			return this.leftValues.indexOf(true) == -1;
		},
		ableConfirm() {
			return (
				this.selectedOrganisms.length != this.secondaryOrganisms.length ||
				this.secondaryOrganisms.some(
					(el) => !this.selectedOrganisms.includes(el)
				)
			);
		},
	},
	methods: {
		closeDialogForm() {
			this.show = false;
			this.$emit("close");
		},
		getOrganisms() {
			this.$extractions
				.getAllOrganisms()
				.then((resp) => {
					const secondaryOrgsIds = this.secondaryOrganisms.map((so) => so.id);
					this.selectedOrganisms = this.secondaryOrganisms.slice();
					this.avalaibleOrganisms = resp.data.filter(
						(el) =>
							secondaryOrgsIds.indexOf(el.id) < 0 &&
							el.id != this.projectOrganism.id
					);
					this.rightValues.length = this.selectedOrganisms.length;
					this.leftValues.length = this.avalaibleOrganisms.length;
				})
				.catch((e) => {
					console.log("Error: ", e);
				});
		},
		moveToRight() {
			this.transportElements(
				this.avalaibleOrganisms,
				this.selectedOrganisms,
				this.leftValues
			);
		},
		moveToLeft() {
			this.transportElements(
				this.selectedOrganisms,
				this.avalaibleOrganisms,
				this.rightValues
			);
		},
		transportElements(from, to, selects) {
			let index = selects.indexOf(true);
			while (index != -1) {
				to.push(from[index]);
				from.splice(index, 1);
				selects.splice(index, 1);
				index = selects.indexOf(true);
			}
		},
		updateSecondarys() {
			this.$extractions
				.updateProjectSecondaryOrganism(
					this.projectId,
					this.selectedOrganisms.map((so) => so.id)
				)
				.then((resp) => {
					if (resp.data.success) {
						this.$emit("update-secondaries", this.selectedOrganisms);
						this.$store.dispatch("snackAlert", true);
						this.closeDialogForm();
					}
				})
				.catch(() => {
					this.$store.dispatch("snackAlert", false);
				});
		},
	},
	watch: {},
};
</script>

<style>
.dialogFormModal {
	z-index: 10001;
	height: 75% !important;
	border-radius: 20px !important;
	background-color: white !important;
	width: 60%;
	overflow-x: hidden;
}
.formModalCloseIconContent {
	display: flex;
	justify-content: flex-end;
}
.cancel-btn {
	margin-left: 2%;
	color: rgb(145, 145, 156);
	caret-color: rgb(145, 145, 156);
	box-shadow: none;
}
.form-container {
	display: flex;
	flex-direction: column;
	height: 95%;
	padding: 15px !important;
}
.body-container {
	display: flex;
	flex-direction: row;
}
.footer-container {
	text-align: center;
}
.btn-confirm:hover {
	background-color: #5f98ed !important;
}
.cancel-btn {
	color: #91919c !important;
}
.cancel-btn:hover {
	color: #65656d !important;
}
.cancel-btn::before {
	background-color: transparent !important;
}
.btn-confirm {
	background-color: #5f98ed !important;
}
.formModalCloseIconButton {
	padding-left: 98%;
}
.secondary-v-flex {
	min-height: 80%;
}

.secondary-list-box {
	max-height: 450px;
	overflow-y: auto;
}
</style>

<style scoped></style>
